"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTokenUpdate = setTokenUpdate;
exports.default = void 0;

var _utils = require("../utils");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function tokenUpdate() {
  return _tokenUpdate.apply(this, arguments);
}

function _tokenUpdate() {
  _tokenUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(_utils.fileToken.getToken && (!_utils.fileToken.token || _utils.fileToken.exp < new Date().valueOf()))) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return _utils.fileToken.getToken();

          case 3:
            _utils.fileToken.token = _context.sent;
            _utils.fileToken.exp = new Date().valueOf() + 60 * 60 * 1000;
            params.token = _utils.fileToken.token;

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _tokenUpdate.apply(this, arguments);
}

var params = {
  token: ''
};

function setTokenUpdate() {
  tokenUpdate();
  setInterval(tokenUpdate, 60 * 60 * 1000);
}

var config = {
  placeHolder: '',
  disabled: true,
  toolbarFloat: false,
  toolbar: ['title', 'bold', 'italic', 'underline', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'table', 'link', 'image', // 'hr',
  // 'indent',
  // 'outdent',
  'alignment'],
  pasteImage: true,
  allowedTags: ['br', 'span', 'a', 'img', 'b', 'strong', 'i', 'strike', 'u', 'font', 'p', 'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'h1', 'h2', 'h3', 'h4', 'hr', 'table', 'thead', 'tbody', 'colgroup', 'col', 'tr', 'td'],
  upload: {
    url: 'https://upload.qiniup.com/',
    // 文件上传的接口地址
    params: params,
    // 键值对,指定文件上传接口的额外参数,上传的时候随文件一起提交
    fileKey: 'file',
    // 服务器端获取文件数据的参数名
    connectionCount: 3,
    leaveConfirm: '正在上传文件'
  }
};
var _default = config;
exports.default = _default;